import { render, staticRenderFns } from "./ModalProcedimentosDescartados.vue?vue&type=template&id=11cc56f8&scoped=true"
import script from "./ModalProcedimentosDescartados.vue?vue&type=script&lang=ts"
export * from "./ModalProcedimentosDescartados.vue?vue&type=script&lang=ts"
import style0 from "./ModalProcedimentosDescartados.vue?vue&type=style&index=0&id=11cc56f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cc56f8",
  null
  
)

export default component.exports